import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    language: null,
    openAbonnement: false,
    isFirst: true,
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        changeLanguage: (state, action) => {
            state.language = action.payload;
        }
    }
});

const abonnementSlice = createSlice({
    name: 'openAbonnement',
    initialState,
    reducers: {
        closeAbonnement: (state, action) => {
            state.openAbonnement = false;
            // action.dispatch(setFirst())
        },
        showAbonnement: (state, action) => {
            state.openAbonnement = true;
        }
    }
})

const firstSlice = createSlice({
    name: 'isFirst',
    initialState,
    reducers: {
        setFirst: (state, action) => {
            state.isFirst = false;
        }
    }
})

export const { changeLanguage } = languageSlice.actions;
export const { closeAbonnement, showAbonnement } = abonnementSlice.actions;
export const { setFirst } = firstSlice.actions;

export const store = configureStore({
    reducer: {
        language: languageSlice.reducer,
        abonnement: abonnementSlice.reducer,
        first: firstSlice.reducer
    }
});